import type { FilterType } from "./types/dataTable.types";

import Filters from "@/components/filters/Filters";
import type { useQueryFilterType } from "@/hooks/query/useQueryParams";

interface WpxTableFilterControlsProps<TQueryResponse, TQueryBaseParams> {
  filters: FilterType<TQueryResponse, TQueryBaseParams>;
  showFilters: boolean;
  filterOperation: useQueryFilterType;
  hide?: boolean;
  clearButtonSize?: "sm" | "lg";
}

/**
 * Independent WPX table filter controls that write filter values to URL params.
 *
 * @param {WpxTableFilterControlsProps<TQueryResponse, TQueryBaseParams>} props - Filter controls props.
 * @returns {React.JSX.Element} Rendered filter controls.
 */
const WpxTableFilterControls = <TQueryResponse, TQueryBaseParams>(
  props: WpxTableFilterControlsProps<TQueryResponse, TQueryBaseParams>,
): React.JSX.Element => {
  return <Filters {...props} />;
};

export default WpxTableFilterControls;
export type { WpxTableFilterControlsProps };
